import classNames from "classnames";
import React from "react";
import StarRating from "../../components/StarRating";
import HibuButton from "../../components/HibuButton";

const HeaderContent = ({ merchant, props }) => {
  if (!merchant) {
    return null;
  }

  const { averageRating, numReviews, surveyUrl } = merchant;
  const formattedRating = averageRating.toFixed(1);

  const settings = {
    ratingLimit: parseFloat(props.ratingLimit || "4.0"),
    countLimit: parseInt(props.countLimit || "3", 10),
    showWrite: (props.showWrite || "false").toLowerCase() === "true",
    hideSummary: (props.hideSummary || "false").toLowerCase() === "true",
  };

  const numRatingCheck = (numReviews < settings.countLimit || averageRating < settings.ratingLimit);

  const linkStyles = classNames({
    link: true,
    dark: props.theme === "dark",
  });

  const wrapperStyles = classNames({
    break: props.break === "true",
  });

  if (!settings.showWrite && numRatingCheck) {
    return null;
  }

  return (
    <div className="reviews-header">
      {settings.showWrite && numRatingCheck ? (
        <HibuButton url={surveyUrl} text="Write a Review" popUp={true} />
      ) : (
        <a className={wrapperStyles} href={props.truncateDest || "/reviews"}>
          <div className="rating">
            <span>{formattedRating}</span>
            <StarRating rating={formattedRating} />
          </div>
          {!settings.hideSummary && <div className={linkStyles}>({numReviews} Ratings & Reviews)</div>}
        </a>
      )}
    </div>
  );
};

export default HeaderContent;



// WEBPACK FOOTER //
// ./src/containers/Header/HeaderContent.jsx